import { Tag } from "../../Tag";
import { DefaultFormRenderer } from "./DefaultFormRenderer";
import type { IFormRenderer, FormWrapperOptions, FormButtonOptions } from "./IFormRenderer";

export class CompactFormRenderer implements IFormRenderer {

    renderWrapper(opts: FormWrapperOptions, formItem: any): Tag {
        const requiredMark = opts.required ? {t: "span", class: "required-mark", txt: " *"} : null;
        const labelEl = opts.label ? {
            t: "div", class: "form-c-label",
            c: [opts.label, requiredMark],
        } : null;

        const iconEl = opts.icon ? {t: "span", class: "formi-icon " + opts.icon} : null;
        const hintEl = opts.hint ? {t: "div", class: "formi-hint", txt: opts.hint} : null;

        const classes = ["formi", "form-compact"];
        if (opts.extraClass) { classes.push(opts.extraClass); }

        const infoAttrs: any[] = [
            {n: "name",    v: opts.name},
            {n: "n",       v: opts.name},
            {n: "max",     v: opts.max},
            {n: "t",       v: opts.label},
            {n: "info",    v: 1},
            {n: "choices", v: opts.choices},
        ];
        const validateStr = DefaultFormRenderer.stringifyValidate(opts.validate);
        if (validateStr && validateStr !== "{}") {
            infoAttrs.push({n: "validate", v: validateStr});
        }

        return new Tag({
            attributes: [
                {n: "formi", v: 1},
                {n: "id",    v: opts.id},
            ],
            c: [
                {
                    attributes: infoAttrs,
                    c: [{
                        c: [
                            labelEl,
                            {c: [iconEl, formItem], class: "form-c-field", t: "div"},
                            hintEl,
                            {t: "div", class: "state"},
                        ],
                        classes: ["fc", "form-c-row"],
                        t:       "div",
                    }],
                    t: "div",
                },
            ],
            classes,
            t:       "div",
        });
    }

    renderButton(opts: FormButtonOptions): Tag {
        const iconBox = opts.icon ? {t: "span", class: opts.icon} : undefined;
        const buttonClasses = ["buttonbox", "fc"];
        if (opts.extraClass) { buttonClasses.push(opts.extraClass); }

        return new Tag({
            attributes: [{n: "formi", v: 1}],
            c: [
                {t: "div", class: "state"},
                {
                    c: [{
                        attributes: [
                            {n: "ft",     v: opts.ft},
                            {n: "formid", v: opts.formId},
                        ],
                        c:       [iconBox, opts.label],
                        classes: buttonClasses,
                        t:       "div",
                    }],
                    class: "form-c-row",
                    t:     "div",
                },
            ],
            classes: ["formi", "form-compact"],
            t:       "div",
        });
    }

    renderState(wrapper: Element, state: "idle" | "loading" | "error" | "success", msg?: string): void {
        if (!wrapper) { return; }
        const stateEl = wrapper.querySelector(".state");
        if (!stateEl) { return; }
        const stateClass = state === "error"   ? "state state--error field-error"
                         : state === "success" ? "state state--success field-success"
                         : state === "loading" ? "state state--loading"
                         :                       "state state--idle";
        stateEl.className = stateClass;
        stateEl.textContent = msg || "";
        const input = wrapper.querySelector("input, textarea, select");
        if (input) {
            input.classList.toggle("is-error", state === "error");
            input.classList.toggle("is-valid", state === "success");
        }
    }
}
